<template>
    <VirtualScroller :items="['Appendix_A', 'Appendix_B', 'Appendix_C', 'Appendix_D']" :itemSize="4"
        style="height: calc(100vh - 208px - 4rem);" :scrollWidth="1129">
        <template v-slot:item="{ item, options }">
            <div class="appendix" id="Appendix_A" v-if="item == 'Appendix_A'">
                <div class="page" style="position:relative" id="refHeight">
                    <div class="cover">
                        <h1>Appendix A</h1>
                        <h1>Project Implementation Program</h1>
                    </div>
                </div>
                <ReportGantt :project="project" title="Appendix A-1 Project Implementation Program"></ReportGantt>
                <div class="page" v-if="project.siteImage.length > 0">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold">
                            Appendix A-2 Location of representative NSRs in the vicinity of the project site
                        </div>
                    </div>
                    <div style="position: relative;display: inline;">
                        <img alt="Project Site Image" :src="project.siteImage[0]" crossorigin="anonymous"
                            style="width:100%" />
                        <template v-for="image in project.siteImage.slice(1)">
                            <img :src="image" alt="Project Site Image" crossorigin="anonymous"
                                style="width:100%;position:absolute;bottom:0;right:0" />
                        </template>
                    </div>
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-1" style="border:2px solid red;">
                        </div>
                        <div class="field col-12 md:col-2">
                            Zone Boundary
                        </div>
                        <div class="field col-12 md:col-1"
                            style="border:2px solid rgba(0, 255, 0, 1);border-style: dashed;">
                        </div>
                        <div class="field col-12 md:col-2">
                            Site Buffer
                        </div>
                        <div class="field col-12 md:col-1" style="border:2px solid blue;">
                        </div>
                        <div class="field col-12 md:col-2">
                            NSR Residential Building
                        </div>
                        <div class="field col-12 md:col-1" style="border:2px solid green;">
                        </div>
                        <div class="field col-12 md:col-2">
                            NSR Education Building
                        </div>
                        <div class="field col-12 md:col-1"
                            style="display: flex;justify-content: center;align-items: center;">
                            <div style="border:2px solid black;width:10px;height:10px;border-radius: 5px;"></div>
                        </div>
                        <div class="field col-12 md:col-2">
                            Geographical Centre
                        </div>
                        <div class="field col-12 md:col-1"
                            style="display: flex;justify-content: center;align-items: center;">
                            <div style="border:2px solid rgba(0, 255, 0, 1);width:10px;height:10px;border-radius: 5px;">
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            Noise Receiver (Satisfy Noise Criteria)
                        </div>
                        <div class="field col-12 md:col-1"
                            style="display: flex;justify-content: center;align-items: center;">
                            <div style="border:2px solid red;width:10px;height:10px;border-radius: 5px;"></div>
                        </div>
                        <div class="field col-12 md:col-3">
                            Noise Receiver (Exceed Noise Criteria)
                        </div>
                    </div>
                </div>
            </div>
            <div class="appendix" id="Appendix_B" v-if="item == 'Appendix_B'">
                <div class="page" style="position:relative">
                    <div class="cover">
                        <h1>Appendix B</h1>
                        <h1>Calculation of Construction Noise Impact Assessment (Unmitigated Scenario)</h1>
                    </div>
                </div>
                <div class="page" v-for="(tasks, page) in splitToPages(project.tasks, 26, 26)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-1 Summary Table of Construction Activity Code
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 40px;">Code</th>
                                <th>Zone</th>
                                <th>Construction Activity</th>
                            </tr>
                            <template v-for="task in tasks">
                                <tr>
                                    <td style="text-align: center;">{{ task.index }}</td>
                                    <td>{{ getZoneName(task.zone) }}</td>
                                    <td>{{ task.name }}</td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-for="(combinations, page) in splitToPages(taskCombination, 52, 52)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-2 Summary Table of Construction Activity Combination Code
                        </div>
                        <template v-for="index in [1, 2]">
                            <div class="field col-12 md:col-6" v-if="combinations.slice(26, 52).length > 0">
                                <table class="table" v-if="combinations.slice((index - 1) * 26, index * 26).length > 0">
                                    <tr class="header">
                                        <th style="width: 40px;">Code</th>
                                        <th>Construction Activity Combination</th>
                                    </tr>
                                    <template v-for="combination in combinations.slice((index - 1) * 26, index * 26)">
                                        <tr>
                                            <td style="text-align: center;">{{ combination.index }}</td>
                                            <td>{{ combination.combinationString }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                            <div class="field col-12" v-else>
                                <table class="table" v-if="combinations.slice((index - 1) * 26, index * 26).length > 0">
                                    <tr class="header">
                                        <th style="width: 40px;">Code</th>
                                        <th>Construction Activity Combination</th>
                                    </tr>
                                    <template v-for="combination in combinations.slice((index - 1) * 26, index * 26)">
                                        <tr>
                                            <td style="text-align: center;">{{ combination.index }}</td>
                                            <td>{{ combination.combinationString }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="page"
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrUnmitigated).sort((a, b) => (nsrUnmitigated[a].nsrname > nsrUnmitigated[b].nsrname) ? 1 : -1), 25, 26)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-3 Summary Table of Calculated Construction Noise Level at NSRs (Unmitigated
                            Scenario)
                        </div>
                        <table class="table" id="b3" style="transform-origin: top left;">
                            <tr class="header">
                                <th rowspan="3" style="width: 70px;">NSR Label</th>
                                <th rowspan="3" style="width: 180px;">Descriptions</th>
                                <th :colspan="getNSRTasks(nsrUnmitigated, buildingids).length">Construction Noise Level
                                    from
                                    Each Work Group</th>
                                <th rowspan="2" :colspan="taskCombination.length" v-if="taskCombination.length > 0">
                                    Cumulative
                                    Construction Noise Due to
                                    Concurrent Works</th>
                                <th rowspan="3" style="width: 80px;">Highest Noise Level, dB(A)</th>
                                <th rowspan="3" style="width: 80px;">Noise Criteria, dB(A)</th>
                            </tr>
                            <tr class="header">
                                <template v-for="zone in getNSRZones(nsrUnmitigated, buildingids)">
                                    <th
                                        :colspan="getNSRTasks(nsrUnmitigated, buildingids).filter(t => t.zone == zone.id).length">
                                        {{ zone.name }}
                                    </th>
                                </template>
                            </tr>
                            <tr class="header">
                                <template v-for="(task, index) in getNSRTasks(nsrUnmitigated, buildingids)">
                                    <th>{{ task.index }}</th>
                                </template>
                                <template v-for="combination in taskCombination">
                                    <th>
                                        {{
                                            combination.index
                                        }}
                                    </th>
                                </template>
                            </tr>
                            <template v-for="id in buildingids">
                                <tr>
                                    <td>
                                        {{ nsrUnmitigated[id].nsrname }}
                                    </td>
                                    <td>
                                        {{ nsrUnmitigated[id].buildingName }}
                                    </td>
                                    <template v-for="zone in getNSRZones(nsrUnmitigated, buildingids)">
                                        <template
                                            v-for="task in getNSRTasks(nsrUnmitigated, buildingids).filter(t => t.zone == zone.id)">
                                            <td v-if="!nsrUnmitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`]">-
                                            </td>
                                            <td v-else class="number" :style="{
                                                'font-weight': Math.round(nsrUnmitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl) > nsrUnmitigated[id].noiseCriteria ? 'bold' : 'normal',
                                                'background': Math.round(nsrUnmitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl) > nsrUnmitigated[id].noiseCriteria ? '#cbcbcb' : 'white'
                                            }">{{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl)
                                            }}
                                            </td>
                                        </template>
                                    </template>
                                    <template v-for="combination in taskCombination">
                                        <td v-if="nsrUnmitigated[id].zonetaskorcombined[combination.combination]"
                                            class="number" :style="{
                                                'font-weight': Math.round(nsrUnmitigated[id].zonetaskorcombined[combination.combination].cnl) > nsrUnmitigated[id].noiseCriteria ? 'bold' : 'normal',
                                                'background': Math.round(nsrUnmitigated[id].zonetaskorcombined[combination.combination].cnl) > nsrUnmitigated[id].noiseCriteria ? '#cbcbcb' : 'white'
                                            }">{{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[combination.combination].cnl)
                                            }}
                                        </td>
                                        <td v-else class="number">
                                            -
                                        </td>
                                    </template>
                                    <td class="number" :style="{
                                        'font-weight': Math.round(nsrUnmitigated[id].highestnoiselevel) > nsrUnmitigated[id].noiseCriteria ? 'bold' : 'normal'
                                    }">
                                        <div>{{ Math.round(nsrUnmitigated[id].highestnoiselevel) }}</div>
                                        <!-- <div v-if="nsrUnmitigated[id].othernoisecriteriaexceed[0] != ''">
                                    ({{
                                        Math.round(nsrUnmitigated[id].highestnoiselevelwithneighbour)
                                    }})</div> -->
                                    </td>
                                    <td class="number">
                                        {{ nsrUnmitigated[id].noiseCriteria }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page"
                    v-for="(calcResultDetailsUnmitigated, page) in splitToPages(project.calcResultDetailsUnmitigated, 22, 23)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-4 Plant Inventory and Calculation of Construction Noise Impact Assessment
                            (Unmitigated
                            Scenario)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 200px;">Construction Activity</th>
                                <th style="width: 110px;" v-if="exclusiveGroupCount > 1">Sub. Work Group</th>
                                <th>Powered Mechanical Equipment</th>
                                <th style="width: 60px;">TM Ref.</th>
                                <th style="width: 80px;">SWL per unit, dB(A)</th>
                                <th style="width: 25px;">Qty</th>
                                <th style="width: 60px;">% Operating Time</th>
                                <th style="width: 60px;">Time Correction, dB(A)</th>
                                <th style="width: 60px;">Total, SWL</th>
                                <th style="width: 80px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Highest SWL of Each Construction Activity, dB(A) </th>
                            </tr>
                            <template v-for="(calcResultDetail, index) in calcResultDetailsUnmitigated">
                                <tr>
                                    <td :rowspan="calcResultDetailsUnmitigated.filter(c => c.taskid == calcResultDetail.taskid).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsUnmitigated[index - 1]?.taskid">
                                        {{
                                            getConstructionActivity(calcResultDetail.taskid) == "-" ?
                                                getTaskName(calcResultDetail.taskid)
                                                :
                                                `${getConstructionActivity(calcResultDetail.taskid)}
                                        - ${getTaskName(calcResultDetail.taskid)}`
                                        }}
                                    </td>
                                    <td :rowspan="calcResultDetailsUnmitigated.filter(c => c.taskid == calcResultDetail.taskid && c.exclusivegroup == calcResultDetail.exclusivegroup).length"
                                        v-if="exclusiveGroupCount > 1 && (index == 0 || calcResultDetail.taskid != calcResultDetailsUnmitigated[index - 1]?.taskid || calcResultDetail.exclusivegroup != calcResultDetailsUnmitigated[index - 1]?.exclusivegroup)">
                                        {{ calcResultDetail.exclusivegroup ? calcResultDetail.exclusivegroup : '-' }}
                                    </td>
                                    <td>
                                        {{ calcResultDetail.pmename }}
                                    </td>
                                    <td>
                                        {{ calcResultDetail.pmeref }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.swl }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.qty }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.timepercent }}%
                                    </td>
                                    <td class="number">
                                        {{ Math.round(calcResultDetail.timecorrection) }}
                                    </td>
                                    <td class="number">
                                        {{ Math.round(calcResultDetail.totalswl) }}
                                    </td>
                                    <td class="number"
                                        :rowspan="calcResultDetailsUnmitigated.filter(c => c.taskid == calcResultDetail.taskid && c.exclusivegroup == calcResultDetail.exclusivegroup).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsUnmitigated[index - 1]?.taskid || calcResultDetail.exclusivegroup != calcResultDetailsUnmitigated[index - 1]?.exclusivegroup">
                                        {{ Math.round(calcResultDetail.groupswl) }}
                                    </td>
                                    <td class="number"
                                        :rowspan="calcResultDetailsUnmitigated.filter(c => c.taskid == calcResultDetail.taskid).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsUnmitigated[index - 1]?.taskid">
                                        {{ Math.round(calcResultDetail.highestswl) }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-if="getAvgNSRTasksCount(nsrUnmitigated) > 30"
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrUnmitigated).flatMap(id => Array(Math.ceil(getNSRTasks(nsrUnmitigated, [id]).length / 30)).fill(id)).sort((a, b) => (nsrUnmitigated[a].nsrname > nsrUnmitigated[b].nsrname) ? 1 : -1), Math.ceil(30 / getAvgNSRTasksCount(nsrUnmitigated)), Math.ceil(30 / getAvgNSRTasksCount(nsrUnmitigated)))">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-5 Calculation of Construction Noise Level (Unmitigated Scenario)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 70px;">NSR Label</th>
                                <th colspan="2">Construction Activity</th>
                                <th style="width: 100px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Horz. Distance, m</th>
                                <th style="width: 100px;">Dist. Corr., dB(A)</th>
                                <th style="width: 100px;">Façade Corr., dB(A)</th>
                                <th style="width: 100px;">CNL, dB(A)</th>
                            </tr>
                            <template v-for="id in buildingids">
                                <template
                                    v-for="(task, index) in getNSRTasks(nsrUnmitigated, [id]).slice(30 * (page % Math.ceil(getNSRTasks(nsrUnmitigated, [id]).length / 30)), 30 * ((page % Math.ceil(getNSRTasks(nsrUnmitigated, [id]).length / 30)) + 1) > getNSRTasks(nsrUnmitigated, [id]).length ? getNSRTasks(nsrUnmitigated, [id]).length : 30 * ((page % Math.ceil(getNSRTasks(nsrUnmitigated, [id]).length / 30)) + 1))">
                                    <!-- hide rows not contributing to that nsr -->
                                    <tr>
                                        <td :rowspan="getNSRTasks(nsrUnmitigated, [id]).length" v-if="index == 0">
                                            {{ nsrUnmitigated[id].nsrname }}
                                        </td>
                                        <td style="width:50px">
                                            {{ task.index }}
                                        </td>
                                        <td>
                                            {{ task.name }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(project.calcResultDetailsUnmitigated.filter(c => c.taskid ==
                                                    task.id)[0].highestswl)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distance)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distancecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{

                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].facadecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].cnl)
                                            }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="index == getNSRTasks(nsrUnmitigated, [id]).length - 1 && buildingids.indexOf(id) != buildingids.length - 1">
                                        <td colspan="8"></td>
                                    </tr>
                                </template>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-else
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrUnmitigated).sort((a, b) => (nsrUnmitigated[a].nsrname > nsrUnmitigated[b].nsrname) ? 1 : -1), Math.ceil(30 / getAvgNSRTasksCount(nsrUnmitigated)), Math.ceil(30 / getAvgNSRTasksCount(nsrUnmitigated)))">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix B-5 Calculation of Construction Noise Level (Unmitigated Scenario)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 70px;">NSR Label</th>
                                <th colspan="2">Construction Activity</th>
                                <th style="width: 100px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Horz. Distance, m</th>
                                <th style="width: 100px;">Dist. Corr., dB(A)</th>
                                <th style="width: 100px;">Façade Corr., dB(A)</th>
                                <th style="width: 100px;">CNL, dB(A)</th>
                            </tr>
                            <template v-for="id in buildingids">
                                <template v-for="(task, index) in getNSRTasks(nsrUnmitigated, [id])">
                                    <!-- hide rows not contributing to that nsr -->
                                    <tr>
                                        <td :rowspan="getNSRTasks(nsrUnmitigated, [id]).length" v-if="index == 0">
                                            {{ nsrUnmitigated[id].nsrname }}
                                        </td>
                                        <td style="width:50px"
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{ task.index }}
                                        </td>
                                        <td
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{ task.name }}
                                        </td>
                                        <td class="number"
                                            v-if="project.calcResultDetailsUnmitigated.filter(c => c.taskid ==
                                                task.id).length > 0 && nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{
                                                Math.round(project.calcResultDetailsUnmitigated.filter(c => c.taskid ==
                                                    task.id)[0].highestswl)
                                            }}
                                        </td>
                                        <td class="number"
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distance)
                                            }}
                                        </td>
                                        <td class="number"
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distancecorr)
                                            }}
                                        </td>
                                        <td class="number"
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{

                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].facadecorr)
                                            }}
                                        </td>
                                        <td class="number"
                                            v-if="nsrUnmitigated[id] && nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`]">
                                            {{
                                                Math.round(nsrUnmitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].cnl)
                                            }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="index == getNSRTasks(nsrUnmitigated, [id]).length - 1 && buildingids.indexOf(id) != buildingids.length - 1">
                                        <td colspan="8"></td>
                                    </tr>
                                </template>
                            </template>
                        </table>
                    </div>
                </div>
                <ReportNoiseGantt :project="project" :nsrData="nsrUnmitigated"
                    title="Appendix B-6 Calculation of Construction Noise Level Schedule (Unmitigated Scenario)">
                </ReportNoiseGantt>
            </div>
            <div class="appendix" id="Appendix_C" v-if="item == 'Appendix_C'">
                <div class="page" style="position:relative">
                    <div class="cover">
                        <h1>Appendix C</h1>
                        <h1>Calculation of Construction Noise Impact Assessment</h1>
                        <h1>(Mitigated Scenario with QPMEs and Noise Barriers)</h1>
                    </div>
                </div>
                <div class="page" v-for="(tasks, page) in splitToPages(project.tasks, 26, 26)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-1 Summary Table of Construction Activity Code
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 40px;">Code</th>
                                <th>Zone</th>
                                <th>Construction Activity</th>
                            </tr>
                            <template v-for="task in tasks">
                                <tr>
                                    <td style="text-align: center;">{{ task.index }}</td>
                                    <td>{{ getZoneName(task.zone) }}</td>
                                    <td>{{ task.name }}</td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-for="(combinations, page) in splitToPages(taskCombination, 52, 52)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-2 Summary Table of Construction Activity Combination Code
                        </div>
                        <template v-for="index in [1, 2]">
                            <div class="field col-12 md:col-6" v-if="combinations.slice(26, 52).length > 0">
                                <table class="table" v-if="combinations.slice((index - 1) * 26, index * 26).length > 0">
                                    <tr class="header">
                                        <th style="width: 40px;">Code</th>
                                        <th>Construction Activity Combination</th>
                                    </tr>
                                    <template v-for="combination in combinations.slice((index - 1) * 26, index * 26)">
                                        <tr>
                                            <td style="text-align: center;">{{ combination.index }}</td>
                                            <td>{{ combination.combinationString }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                            <div class="field col-12" v-else>
                                <table class="table" v-if="combinations.slice((index - 1) * 26, index * 26).length > 0">
                                    <tr class="header">
                                        <th style="width: 40px;">Code</th>
                                        <th>Construction Activity Combination</th>
                                    </tr>
                                    <template v-for="combination in combinations.slice((index - 1) * 26, index * 26)">
                                        <tr>
                                            <td style="text-align: center;">{{ combination.index }}</td>
                                            <td>{{ combination.combinationString }}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="page"
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrMitigated).sort((a, b) => (nsrMitigated[a].nsrname > nsrMitigated[b].nsrname) ? 1 : -1), 25, 26)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-3 Summary Table of Calculated Construction Noise Level at NSRs (Mitigated
                            Scenario
                            with
                            QPMEs and Movable Noise Barriers)
                        </div>
                        <table class="table" id="c3" style="transform-origin: top left;">
                            <tr class="header">
                                <th rowspan="3" style="width: 70px;">NSR Label</th>
                                <th rowspan="3" style="width: 180px;">Descriptions</th>
                                <th :colspan="getNSRTasks(nsrMitigated, buildingids).length">Construction Noise Level
                                    from
                                    Each Work Group</th>
                                <th rowspan="2" :colspan="taskCombination.length" v-if="taskCombination.length > 0">
                                    Cumulative
                                    Construction Noise Due to
                                    Concurrent Works</th>
                                <th rowspan="3" style="width: 80px;">Highest Noise Level, dB(A) (with Neighbor Site
                                    Contribution)
                                </th>
                                <th rowspan="3" style="width: 80px;">Noise Criteria, dB(A)</th>
                            </tr>
                            <tr class="header">
                                <template v-for="zone in getNSRZones(nsrMitigated, buildingids)">
                                    <th
                                        :colspan="getNSRTasks(nsrMitigated, buildingids).filter(t => t.zone == zone.id).length">
                                        {{ zone.name }}
                                    </th>
                                </template>
                            </tr>
                            <tr class="header">
                                <template v-for="(task, index) in getNSRTasks(nsrMitigated, buildingids)">
                                    <th>{{ task.index }}</th>
                                </template>
                                <template v-for="combination in taskCombination">
                                    <th>
                                        {{
                                            combination.index
                                        }}
                                    </th>
                                </template>
                            </tr>
                            <template v-for="id in buildingids">
                                <tr>
                                    <td>
                                        {{ nsrMitigated[id].nsrname }}
                                    </td>
                                    <td>
                                        {{ nsrMitigated[id].buildingName }}
                                    </td>
                                    <template v-for="zone in getNSRZones(nsrMitigated, buildingids)">
                                        <template
                                            v-for="task in getNSRTasks(nsrMitigated, buildingids).filter(t => t.zone == zone.id)">
                                            <td v-if="nsrMitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`]"
                                                class="number" :style="{
                                                    'font-weight': Math.round(nsrMitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl) > nsrMitigated[id].noiseCriteria ? 'bold' : 'normal',
                                                    'background': Math.round(nsrMitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl) > nsrMitigated[id].noiseCriteria ? '#cbcbcb' : 'white'
                                                }">
                                                {{
                                                    Math.round(nsrMitigated[id].zonetaskorcombined[`${zone.id}-${task.id}`].cnl)
                                                }}
                                            </td>
                                            <td v-else>-</td>
                                        </template>
                                    </template>
                                    <template v-for="combination in taskCombination">
                                        <td v-if="nsrMitigated[id].zonetaskorcombined[combination.combination]"
                                            class="number" :style="{
                                                'font-weight': Math.round(nsrMitigated[id].zonetaskorcombined[combination.combination].cnl) > nsrMitigated[id].noiseCriteria ? 'bold' : 'normal',
                                                'background': Math.round(nsrMitigated[id].zonetaskorcombined[combination.combination].cnl) > nsrMitigated[id].noiseCriteria ? '#cbcbcb' : 'white'
                                            }">{{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[combination.combination].cnl)
                                            }}
                                        </td>
                                        <td v-else class="number">
                                            -
                                        </td>
                                    </template>
                                    <td class="number" :style="{
                                        'font-weight': Math.round(nsrMitigated[id].highestnoiselevel) > nsrMitigated[id].noiseCriteria ? 'bold' : 'normal'
                                    }">
                                        <div>{{ Math.round(nsrMitigated[id].highestnoiselevel) }}</div>
                                        <div v-if="nsrMitigated[id].othernoisecriteriaexceed[0] != ''">
                                            ({{
                                                Math.round(nsrMitigated[id].highestnoiselevelwithneighbour)
                                            }})</div>
                                    </td>
                                    <td class="number">
                                        {{ nsrMitigated[id].noiseCriteria }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page"
                    v-for="(calcResultDetailsMitigated, page) in splitToPages(project.calcResultDetailsMitigated, 10, 10)">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-4 Plant Inventory and Calculated SWLs for Construction Noise Impact Assessment
                            (with
                            QPMEs, Movable
                            Noise Barriers)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 120px;">Construction Activity</th>
                                <th style="width: 110px;" v-if="exclusiveGroupCount > 1">Sub. Work Group</th>
                                <th>Powered Mechanical Equipment</th>
                                <th style="width: 60px;">TM Ref.</th>
                                <th style="width: 80px;">SWL per unit, dB(A)</th>
                                <th style="width: 25px;">Qty</th>
                                <th style="width: 60px;">% Operating Time</th>
                                <th style="width: 60px;">Time Correction, dB(A)</th>
                                <th style="width: 60px;">Total, SWL</th>
                                <th style="width: 60px;">At-source Noise Mitigation Measure</th>
                                <th style="width: 60px;">Mitigation Effect</th>
                                <th style="width: 60px;">Total SWL (Mitigated)</th>
                                <th style="width: 80px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Highest SWL of Each Construction Activity, dB(A) </th>
                            </tr>
                            <template v-for="(calcResultDetail, index) in calcResultDetailsMitigated">
                                <tr>
                                    <td :rowspan="calcResultDetailsMitigated.filter(c => c.taskid == calcResultDetail.taskid).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsMitigated[index - 1].taskid">
                                        {{
                                            getConstructionActivity(calcResultDetail.taskid) == "-" ?
                                                getTaskName(calcResultDetail.taskid)
                                                :
                                                `${getConstructionActivity(calcResultDetail.taskid)}
                                        - ${getTaskName(calcResultDetail.taskid)}`
                                        }}
                                    </td>
                                    <td :rowspan="calcResultDetailsMitigated.filter(c => c.taskid == calcResultDetail.taskid && c.exclusivegroup == calcResultDetail.exclusivegroup).length"
                                        v-if="exclusiveGroupCount > 1 && (index == 0 || calcResultDetail.taskid != calcResultDetailsMitigated[index - 1].taskid || calcResultDetail.exclusivegroup != calcResultDetailsMitigated[index - 1].exclusivegroup)">
                                        {{ calcResultDetail.exclusivegroup ? calcResultDetail.exclusivegroup : '-' }}
                                    </td>
                                    <td>
                                        {{ calcResultDetail.pmename }}
                                    </td>
                                    <td>
                                        {{ calcResultDetail.pmeref }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.swl }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.qty }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.timepercent }}%
                                    </td>
                                    <td class="number">
                                        {{ Math.round(calcResultDetail.timecorrection) }}
                                    </td>
                                    <td class="number">
                                        {{ Math.round(calcResultDetail.totalswl) }}
                                    </td>
                                    <td>
                                        {{ calcResultDetail.mitigationmeasure }}
                                    </td>
                                    <td class="number">
                                        {{ calcResultDetail.mitigationeffect }}
                                    </td>
                                    <td class="number">
                                        {{ Math.round(calcResultDetail.mitigatedswl) }}
                                    </td>
                                    <td class="number"
                                        :rowspan="calcResultDetailsMitigated.filter(c => c.taskid == calcResultDetail.taskid && c.exclusivegroup == calcResultDetail.exclusivegroup).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsMitigated[index - 1].taskid || calcResultDetail.exclusivegroup != calcResultDetailsMitigated[index - 1].exclusivegroup">
                                        {{ Math.round(calcResultDetail.groupswl) }}
                                    </td>
                                    <td class="number"
                                        :rowspan="calcResultDetailsMitigated.filter(c => c.taskid == calcResultDetail.taskid).length"
                                        v-if="index == 0 || calcResultDetail.taskid != calcResultDetailsMitigated[index - 1].taskid">
                                        {{ Math.round(calcResultDetail.highestswl) }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-if="getAvgNSRTasksCount(nsrMitigated) > 30"
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrMitigated).flatMap(id => Array(Math.ceil(getNSRTasks(nsrMitigated, [id]).length / 30)).fill(id)).sort((a, b) => (nsrMitigated[a].nsrname > nsrMitigated[b].nsrname) ? 1 : -1), Math.ceil(30 / getAvgNSRTasksCount(nsrMitigated)), Math.ceil(30 / getAvgNSRTasksCount(nsrMitigated)))">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-5 Calculation of Construction Noise Level (Mitigated Scenario with QPMEs and
                            Movable
                            Noise Barriers)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 70px;">NSR Label</th>
                                <th colspan="2">Construction Activity</th>
                                <th style="width: 100px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Horz. Distance, m</th>
                                <th style="width: 100px;">Dist. Corr., dB(A)</th>
                                <th style="width: 100px;">Façade Corr., dB(A)</th>
                                <th style="width: 100px;">CNL, dB(A)</th>
                            </tr>
                            <template v-for="id in buildingids">
                                <template
                                    v-for="(task, index) in getNSRTasks(nsrMitigated, [id]).slice(30 * (page % Math.ceil(getNSRTasks(nsrMitigated, [id]).length / 30)), 30 * ((page % Math.ceil(getNSRTasks(nsrMitigated, [id]).length / 30)) + 1) > getNSRTasks(nsrMitigated, [id]).length ? getNSRTasks(nsrMitigated, [id]).length : 30 * ((page % Math.ceil(getNSRTasks(nsrMitigated, [id]).length / 30)) + 1))">
                                    <!-- hide rows not contributing to that nsr -->
                                    <tr>
                                        <td :rowspan="project.tasks.length" v-if="index == 0">
                                            {{ nsrMitigated[id].nsrname }}
                                        </td>
                                        <td style="width:50px">
                                            {{ task.index }}
                                        </td>
                                        <td>
                                            {{ task.name }}
                                        </td>
                                        <td class="number" v-if="project.calcResultDetailsMitigated.filter(c => c.taskid ==
                                            task.id).length > 0">
                                            {{
                                                Math.round(project.calcResultDetailsMitigated.filter(c => c.taskid ==
                                                    task.id)[0].highestswl)
                                            }}
                                        </td>
                                        <td class="number" v-else>-</td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distance)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distancecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{

                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].facadecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].cnl)
                                            }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="index == getNSRTasks(nsrMitigated, [id]).length - 1 && buildingids.indexOf(id) != buildingids.length - 1">
                                        <td colspan="8"></td>
                                    </tr>
                                </template>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="page" v-else
                    v-for="(buildingids, page) in splitToPages(Object.keys(nsrMitigated).sort((a, b) => nsrMitigated[a].nsrname.localeCompare(nsrMitigated[b].nsrname, undefined, { numeric: true, sensitivity: 'base' })), Math.ceil(30 / getAvgNSRTasksCount(nsrMitigated)), Math.ceil(30 / getAvgNSRTasksCount(nsrMitigated)))">
                    <div class="formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;"
                            v-if="page == 0">
                            Appendix C-5 Calculation of Construction Noise Level (Mitigated Scenario with QPMEs and
                            Movable
                            Noise Barriers)
                        </div>
                        <table class="table">
                            <tr class="header">
                                <th style="width: 70px;">NSR Label</th>
                                <th colspan="2">Construction Activity</th>
                                <th style="width: 100px;">Total SWL, dB(A)</th>
                                <th style="width: 100px;">Horz. Distance, m</th>
                                <th style="width: 100px;">Dist. Corr., dB(A)</th>
                                <th style="width: 100px;">Façade Corr., dB(A)</th>
                                <th style="width: 100px;">CNL, dB(A)</th>
                            </tr>
                            <template v-for="id in buildingids">
                                <template v-for="(task, index) in getNSRTasks(nsrMitigated, [id])">
                                    <!-- hide rows not contributing to that nsr -->
                                    <tr>
                                        <td :rowspan="getNSRTasks(nsrMitigated, [id]).length" v-if="index == 0">
                                            {{ nsrMitigated[id].nsrname }}
                                        </td>
                                        <td style="width:50px">
                                            {{ task.index }}
                                        </td>
                                        <td>
                                            {{ task.name }}
                                        </td>
                                        <td class="number" v-if="project.calcResultDetailsMitigated.filter(c => c.taskid ==
                                            task.id).length > 0">
                                            {{
                                                Math.round(project.calcResultDetailsMitigated.filter(c => c.taskid ==
                                                    task.id)[0].highestswl)
                                            }}
                                        </td>
                                        <td v-else>-</td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distance)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].distancecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{

                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].facadecorr)
                                            }}
                                        </td>
                                        <td class="number">
                                            {{
                                                Math.round(nsrMitigated[id].zonetaskorcombined[`${task.zone}-${task.id}`].cnl)
                                            }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="index == getNSRTasks(nsrMitigated, [id]).length - 1 && buildingids.indexOf(id) != buildingids.length - 1">
                                        <td colspan="8"></td>
                                    </tr>
                                </template>
                            </template>
                        </table>
                    </div>
                </div>
                <ReportNoiseGantt :project="project" :nsrData="nsrMitigated"
                    title="Appendix C-6 Calculation of Construction Noise Level Schedule (Mitigated Scenario)">
                </ReportNoiseGantt>
            </div>
            <div class="appendix" id="Appendix_D" v-if="neighborProjects.length > 0 && item == 'Appendix_D'">
                <div class="page" style="position:relative">
                    <div class="cover">
                        <h1>Appendix D</h1>
                        <h1>Project Implementation Program Due to Planned Site</h1>
                    </div>
                </div>
                <ReportGantt :project="project" title="Appendix D-1 Project Implementation Program"
                    :start="neighborProjects.map(p => p.commencementDate)"
                    :end="neighborProjects.map(p => p.completionDate)"
                    legend="Construction activities that will be construct concurrently with neighbor projects">
                </ReportGantt>
                <template v-for="(p, index) in neighborProjects">
                    <ReportGantt :project="p"
                        :title="`Appendix D-${index + 2} ${p.projectTitle} Implementation Program`"
                        :start="[project.commencementDate]" :end="[project.completionDate]"
                        legend="Construction activities that will be construct concurrently with this project">
                    </ReportGantt>
                </template>
            </div>
        </template>
    </VirtualScroller>
</template>

<script>
import InputLabel from "./InputLabel.vue"
import DropdownLabel from "./DropdownLabel.vue"
import ReportGantt from './ReportGantt.vue'
import ReportNoiseGantt from './ReportNoiseGantt.vue'
import DateHelper from "@/helper/DateHelper"
export default {
    name: 'Appendix',
    props: {
        project: Object,
        neighborProjects: Array,
        printMode: Boolean,
    },
    data() {
        return {
            nsrUnmitigated: {},
            nsrMitigated: {},
            taskCombination: [],
            longestCombination: null,
        }
    },
    computed: {
        getTotalDays() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24)
        },
        getTotalWeeks() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24 * 7)
        },
        getTotalMonths() {
            let d1 = DateHelper.getDate(this.project.commencementDate);
            let d2 = DateHelper.getDate(this.project.completionDate);
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
        exclusiveGroupCount() {
            return [...new Set(this.project.calcResultDetailsUnmitigatedCleaned.map(item => item.exclusivegroup))].length
        },
    },
    methods: {
        getDateString(date) {
            return DateHelper.getDateString(date);
        },
        getDaysBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var days = [];
            while (start <= end) {
                days.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 1);
            }
            return days;
        },
        getWeeksBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var weeks = [];
            while (start <= end) {
                weeks.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 7);
            }
            return weeks;
        },
        getMonthsBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), start.getMonth(), 1);
            var months = [];
            while (date <= new Date(end.getFullYear(), end.getMonth(), 1)) {
                months.push(new Date(date.getFullYear(), date.getMonth(), 1));
                date.setMonth(date.getMonth() + 1);
            }
            return months;
        },
        getYearBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), 0, 1);
            var years = [];
            while (date <= new Date(end.getFullYear(), 0, 1)) {
                years.push(new Date(date.getFullYear(), 0, 1));
                date.setYear(date.getFullYear() + 1);
            }
            return years;
        },
        getDate(date) {
            return DateHelper.getDate(date)
        },
        getZoneName(zoneId) {
            return this.project.zones.filter(z => z.id == zoneId)[0].name;
        },
        getConstructionActivity(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].group;
        },
        getTaskName(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].name;
        },
        splitToPages(list, firstPageCount, otherPageCount) {
            let pages = []
            let sublist = [];
            for (var i = 0; i < list.length; i++) {
                if ((i + 1 - firstPageCount) % otherPageCount == 0) {
                    sublist.push(list[i])
                    pages.push(sublist);
                    sublist = [];
                }
                else {
                    sublist.push(list[i])
                }
            }
            if (sublist.length > 0) {
                pages.push(sublist);
            }
            return pages;
        },
        numberToLetter(num) {
            var s = '';
            var t;
            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s;
        },
        getCombinationString(combination) {
            return combination.split('+').map(c => this.numberToLetter(this.project.tasks.indexOf(this.project.tasks.filter(t => t.id == c.split("-")[1])[0]) + 1)).sort().join('+');
        },
        getNSRTasks(list, ids) {
            if (ids.length > 1) {
                let tasks = [];
                ids.forEach(id => {
                    tasks.push(...this.project.tasks.filter(t => list[id] && list[id].zonetaskorcombined[`${t.zone}-${t.id}`]).filter(t => !tasks.map(t => t.id).includes(t.id)));
                })
                return tasks;
            }
            else {
                return this.project.tasks.filter(t => list[ids[0]] && list[ids[0]].zonetaskorcombined[`${t.zone}-${t.id}`])
            }
        },
        getNSRZones(list, ids) {
            let tasks = this.getNSRTasks(list, ids);
            let zoneIds = tasks.map(t => t.zone);
            return this.project.zones.filter(z => zoneIds.includes(z.id));
        },
        getTotalNSRTasks(list) {
            let count = 0;
            Object.keys(list).forEach(id => {
                count += Object.keys(list[id].zonetaskorcombined).length;
            });
            return count;
        },
        getAvgNSRTasksCount(list) {
            return Math.ceil(this.getTotalNSRTasks(list) / Object.keys(list).length);
        }
    },
    mounted() {
        let props = this;
        [...new Set(this.project.calcResultNSRUnmitigated.map(item => item.nsrpointid))].forEach(nsrpointid => {
            let filtered = props.project.calcResultNSRUnmitigated.filter(item => item.nsrpointid == nsrpointid);
            props.nsrUnmitigated[nsrpointid] = {
                buildingid: filtered[0].buildingid,
                buildingName: filtered[0].buildingName,
                nsrname: filtered[0].nsrname,
                highestnoiselevel: filtered[0].highestnoiselevel,
                highestnoiselevelwithneighbour: Math.max(...filtered.map(f => f.highestnoiselevelwithneighbour)),
                noiseCriteria: filtered[0].noiseCriteria,
                zonetaskorcombined: {},
                othernoisecriteriaexceed: filtered[0].othernoisecriteriaexceed.split("#"),
                othernoisecriteriaexceedmax: filtered[0].othernoisecriteriaexceedmax,
            }
            filtered.forEach(result => {
                if (props.nsrUnmitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined]) {
                    if (result.distance > props.nsrUnmitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined].distance) {
                        props.nsrUnmitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                            cnl: result.cnl,
                            distance: result.distance,
                            distancecorr: result.distancecorr,
                            facadecorr: result.facadecorr,
                        }
                    }
                }
                else {
                    props.nsrUnmitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                        cnl: result.cnl,
                        distance: result.distance,
                        distancecorr: result.distancecorr,
                        facadecorr: result.facadecorr,
                    }
                }
            })
        });
        [...new Set(this.project.calcResultNSRMitigated.map(item => item.nsrpointid))].forEach(nsrpointid => {
            let filtered = props.project.calcResultNSRMitigated.filter(item => item.nsrpointid == nsrpointid);
            props.nsrMitigated[nsrpointid] = {
                buildingid: filtered[0].buildingid,
                buildingName: filtered[0].buildingName,
                nsrname: filtered[0].nsrname,
                highestnoiselevel: filtered[0].highestnoiselevel,
                highestnoiselevelwithneighbour: Math.max(...filtered.map(f => f.highestnoiselevelwithneighbour)),
                noiseCriteria: filtered[0].noiseCriteria,
                zonetaskorcombined: {},
                othernoisecriteriaexceed: filtered[0].othernoisecriteriaexceed.split("#"),
                othernoisecriteriaexceedmax: filtered[0].othernoisecriteriaexceedmax,
            }
            filtered.forEach(result => {
                if (props.nsrMitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined]) {
                    if (result.distance > props.nsrMitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined].distance) {
                        props.nsrMitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                            cnl: result.cnl,
                            distance: result.distance,
                            distancecorr: result.distancecorr,
                            facadecorr: result.facadecorr,
                        }
                    }
                }
                else {
                    props.nsrMitigated[nsrpointid].zonetaskorcombined[result.zonetaskorcombined] = {
                        cnl: result.cnl,
                        distance: result.distance,
                        distancecorr: result.distancecorr,
                        facadecorr: result.facadecorr,
                    }
                }
            })
        });
        // this.taskCombination = [...new Set(this.project.calcResultNSRUnmitigated.map(item => item.zonetaskorcombined))].filter(tc => tc.includes("+")).sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })).map(c => { return { combination: c } });
        this.taskCombination = [...new Set(this.project.calcResultNSRUnmitigated.map(item => item.zonetaskorcombined))].filter(tc => tc.includes("+")).sort().map(c => { return { combination: c } });
        this.project.tasks.sort((a, b) => (this.project.zones.filter(z => z.id == a.zone)[0].name + a.group + a.start).localeCompare(
            this.project.zones.filter(z => z.id == b.zone)[0].name + b.group + b.start, undefined, {
            numeric: true,
            sensitivity: 'base'
        }));
        for (let i = 0; i < this.project.tasks.length; i++) {
            this.project.tasks[i].index = this.numberToLetter(i + 1);
        }
        console.log(this.taskCombination);
        for (let i = 0; i < this.taskCombination.length; i++) {
            this.taskCombination[i].index = `C-${this.numberToLetter(i + 1)}`;
            this.taskCombination[i].combinationString = this.getCombinationString(this.taskCombination[i].combination);
        }
        let longest = [...this.taskCombination.map(tc => tc.combinationString), ...this.project.tasks.map(t => t.name)].sort((a, b) => a.length - b.length);
        this.longestCombination = longest.length > 0 ? longest[longest.length - 1].length * 5 : 0;
    },
    components: {
        InputLabel,
        DropdownLabel,
        ReportGantt,
        ReportNoiseGantt
    }
}
</script>

<style lang="less" scoped>
.appendix {
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
    max-width: 1085px;
}

.center {
    text-align: center;
    width: 100%;
}

.page {
    width: 100%;
    height: auto;
    aspect-ratio: 841.89 / 595.28;
    padding: 15px 20px;
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}

.cover {
    text-align: right;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    width: 90%;
}

.table {
    width: 100%;
    font-size: 12px;
    margin-bottom: 10px;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td {
    padding: 3px
}

.header {
    text-align: center;
    width: 100%;
}

.header>th {
    background-color: rgb(172, 172, 172);
    font-size: 12px;
}

.sub-header {
    text-align: center;
    font-weight: bold;
}

.cell {
    width: 100%;
}

.greyCell {
    background-color: rgb(172, 172, 172);
}

#gantt>tr>td:first-child {
    width: 33%;
}

.number {
    text-align: center
}
</style>